import React from 'react';
import { FaCheckCircle, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import "../Home/theme.css"; // Import the CSS file

const ThankYouPage = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: "var(--gradient-bg)",
      }}
    >
      <div className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="mb-6 flex justify-center">
          <div 
            className="w-24 h-24 rounded-full flex items-center justify-center"
            style={{
              background: "var(--gradient-primary)",
            }}
          >
            <FaCheckCircle className="text-white text-5xl" />
          </div>
        </div>

        {/* Thank You Message */}
        <h1 
          className="text-3xl font-bold mb-4 bell-mt-primary"
          style={{
            color: "var(--color-primary-500)",
          }}
        >
          Thank You!
        </h1>
        <p 
          className="text-lg mb-8 inter-secondary"
          style={{
            color: "var(--color-gray-600)",
          }}
        >
          Your message has been received. We will get back to you soon.
        </p>

        {/* Return Home Button */}
        <Link
          to="/"
          className="inline-flex items-center justify-center text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg inter-secondary"
          style={{
            background: "var(--color-primary-500)",
            color: "var(--color-white)",
          }}
        >
          <FaHome className="mr-2" />
          Return to Homepage
        </Link>

        {/* Optional Additional Info */}
        <div className="mt-8 text-sm inter-secondary" style={{ color: "var(--color-gray-500)" }}>
          <p>Our team typically responds within 24 hours.</p>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;